<template>
  <div class="modal-popup-black">
    <div class="bg"></div>
    <div class="border">
      <div class="pop_up">
        <div class="head">
          <p class="title">{{ title }}</p>
          <div
            class="close"
            @click="eventBybtnCrissCross"
          ></div>
        </div>
        <div class="content">
          <p>{{ text }}</p>
        </div>
        <slot name="content" />
        <div class="buttons-btm">
          <LkButton
            v-if="isShowBtnSecondary"
            @onClick="eventBybtnSecondary"
            :isSecondary="true"
          >
            {{ textBtnSecondary }}
          </LkButton>

          <LkButton @onClick="eventBybtnPrimary">
            {{ textBtnPrimary }}
          </LkButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['eventBybtnPrimary', 'eventBybtnSecondary', 'eventBybtnCrissCross'],
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    textBtnPrimary: {
      type: String
    },
    textBtnSecondary: {
      type: String
    },
    isShowBtnSecondary: {
      type: Boolean,  // default value is false
      default: true
    }
  },
  methods: {
    eventBybtnPrimary () {
      this.$emit('eventBybtnPrimary')
    },
    eventBybtnSecondary () {
      this.$emit('eventBybtnSecondary')
    },
    eventBybtnCrissCross () {
      this.$emit('eventBybtnCrissCross')
    }
  },
  computed: {
    getDeftextBtnPrimary: function () {
      return (
        this.textBtnPrimary ||
        this.$t('pop_ups.login_page.connect_your_open_id.btns.primary')
      )
    },
    getDeftextBtnSecondary: function () {
      return (
        this.textBtnSecondary ||
        this.$t('pop_ups.login_page.connect_your_open_id.btns.secondary')
      )
    }
  }
}
</script>
        


// WEBPACK FOOTER //
// modal-popup-black.vue?053367df